import { helper } from "lib/helper";
import contact_usModel from "models/contact_us.model";
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  Container,
  Row,
  Input,
  Button,
  UncontrolledTooltip,
  CardBody,
  Label,
  Col,
  FormGroup,
  Progress,
  Form,
  ModalHeader,
  ModalBody,
  Modal,
} from "reactstrap";
import AttendanceModel from "models/Attendance.modal";
import { Link } from "react-router-dom";
import moment from "moment";

const AttParentDetails = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [AllClass, setAllClass] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const params = useParams();
  const parameters = {};
  for (let [key, value] of searchParams) {
    parameters[key] = value;
  }

  const GetAllCycle = async () => {
    // await AttendanceModel
    //   .GetAllCycle(params?.id)
    //   .then((result) => {
    //     setIsLoading(false)
    //     if (result) {
    //       setAllClass(result);
    //       console.log(result, 'resultresult')
    //     }
    //   })
    //   .catch((error) => {
    //     helper.sweetalert.toast(error.response?.data?.message, "warning");
    //   });
    const dummyCycles = {
      data: {
        data: [
          {
            id: 1,
            name: "Cycle 1",
            start_date: "2023-01-01",
            end_date: "2023-06-01",
          },
          {
            id: 2,
            name: "Cycle 2",
            start_date: "2023-07-01",
            end_date: "2023-12-01",
          },
        ],
      },
    };
    setAllClass(dummyCycles);
    setIsLoading(false);
  };
  useEffect(() => {
    GetAllCycle();
  }, [location]);

  const [ClassData, setClassData] = useState([]);
  const [sessionPercentage, setSessionPercentage] = useState(0);
  const [remaingSession, setRemaingSession] = useState(0);
  const [futureDate, setFutureDate] = useState("");
  const GetClassDataByid = async () => {
    // await AttendanceModel.GetClassById(params?.id,)
    //   .then((result) => {
    //     if (result) {
    //       setClassData(result?.data?.data);
    //       console.clear();
    //       console.log(result.data);
    //       let totalSession = result?.data?.data?.number_of_session;
    //       let sessionCount = result?.data?.data?.totalSession;
    //       let remainingSessions = 0;
    //       let percent = 0;
    //       //console.log("total = ", totalSession, "session = ", sessionCount);
    //       if (totalSession > sessionCount) {
    //         remainingSessions = totalSession - sessionCount;
    //         percent = Math.floor((sessionCount / totalSession) * 100);

    //         if (remainingSessions > 0) {
    //           //console.log("remain", remaingSession)
    //           const currentDate = new Date();
    //           const futureDateObj = new Date();
    //           futureDateObj.setDate(currentDate.getDate() + remainingSessions);
    //           const formattedDate = futureDateObj.toISOString().split('T')[0];
    //           setFutureDate(formattedDate);
    //         }
    //       } else {
    //         percent = 100;
    //       }
    //       setRemaingSession(remainingSessions);
    //       setSessionPercentage(percent);
    //       console.log("percent = ", percent);
    //     }
    //   })
    const dummyClassData = {
      data: {
        data: {
          id: 1,
          name: "Math Class",
          number_of_session: 20,
          totalSession: 15,
          tutor_name: "John Tutor",
          subject: "Mathematics",
        },
      },
    };
    setClassData(dummyClassData.data.data);
    let totalSession = dummyClassData.data.data.number_of_session;
    let sessionCount = dummyClassData.data.data.totalSession;
    let remainingSessions = 0;
    let percent = 0;
    if (totalSession > sessionCount) {
      remainingSessions = totalSession - sessionCount;
      percent = Math.floor((sessionCount / totalSession) * 100);
      if (remainingSessions > 0) {
        const currentDate = new Date();
        const futureDateObj = new Date();
        futureDateObj.setDate(currentDate.getDate() + remainingSessions);
        const formattedDate = futureDateObj.toISOString().split("T")[0];
        setFutureDate(formattedDate);
      }
    } else {
      percent = 100;
    }
    setRemaingSession(remainingSessions);
    setSessionPercentage(percent);
  };
  useEffect(() => {
    GetClassDataByid();
  }, [location, params?.id]);

  const handleSubmitRemark = (event) => {
    event.preventDefault();
    const form = new FormData(event.target);
    // You can adjust the header configuration according to your API requirements
    AttendanceModel.AttendanceAddRemark(params.id, form)
      .then((response) => {
        helper.sweetalert.toast("Your remark add.", "success");

        // getListData();
        GetClassDataByid();
        toggle();
        // Display success message to the user
      })
      .catch((error) => {
        helper.sweetalert.toast(error?.response?.data?.name[0], "error");
      });
  };

  return (
    <>
      <Container>
        {!isLoading && (
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0 d-flex justify-content-between ">
                  <h3 className="mb-0">Attendance Overview</h3>

                  <Col
                    md={8}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "row",
                    }}
                  >
                    <p>
                      <span
                        style={{
                          fontSize: "16px",
                          fontWeight: "bold",
                        }}
                      >
                        Class Status -
                      </span>

                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: "bold",
                          color: "white",
                          backgroundColor: "green",
                          borderRadius: "10px",
                          marginLeft: "10px",
                          padding: "5px",
                        }}
                      >
                        {" "}
                        {ClassData?.status}
                      </span>
                    </p>
                    <p className="ml-2">
                      <span
                        style={{
                          fontSize: "16px",
                          fontWeight: "bold",
                        }}
                      >
                        Cycle Payment Status -
                      </span>

                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: "bold",
                          color: "white",
                          backgroundColor: "orange",
                          borderRadius: "10px",
                          marginLeft: "10px",
                          padding: "5px",
                        }}
                      >
                        {ClassData?.classcycleData?.parent_fees_status
                          ? ClassData?.classcycleData?.parent_fees_status
                          : "Payment data not updated"}
                      </span>
                    </p>
                  </Col>
                </CardHeader>

                <CardBody>
                  <Row>
                    <Col md={5}>
                      <FormGroup>
                        <Label for="exampleEmail">
                          No. Of Sessions Completed {ClassData?.totalSession}/
                          {ClassData?.number_of_session}
                        </Label>
                        <Progress
                          className="my-2"
                          value={sessionPercentage}
                          style={{ height: "25px" }}
                        >
                          {sessionPercentage}
                        </Progress>
                      </FormGroup>
                    </Col>
                    <Col md={2}></Col>

                    <Col md={5}>
                      <FormGroup>
                        <Label for="exampleEmail"> Remaining Sessions</Label>
                        <p style={{ fontSize: "16px", fontWeight: "bold" }}>
                          {remaingSession}
                        </p>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={5}>
                      <FormGroup>
                        <Label for="exampleEmail">Start Date</Label>
                        <p style={{ fontSize: "16px", fontWeight: "bold" }}>
                          {ClassData?.class_start_day}
                        </p>
                      </FormGroup>
                    </Col>
                    <Col md={2}></Col>

                    <Col md={5}>
                      <FormGroup>
                        <Label for="exampleEmail">End Date</Label>
                        <p style={{ fontSize: "16px", fontWeight: "bold" }}>
                          {moment(ClassData?.start_date)
                            .add(28, "days")
                            .format("YYYY-MM-DD")}
                        </p>
                      </FormGroup>
                    </Col>
                  </Row>

                  {/* <Row>
                    <Col md={5}>
                      <FormGroup>
                        <Label for="exampleEmail">
                          {" "}
                          No. Of hours Completed 2/8
                        </Label>
                        <Progress
                          className="my-2"
                          value="80"
                          style={{ height: "25px" }}
                        >
                          85%
                        </Progress>
                      </FormGroup>
                    </Col>
                    <Col md={2}></Col>

                    <Col md={5}>
                      <FormGroup>
                        <Label for="exampleEmail"> Remaining hours</Label>
                        <p style={{ fontSize: "16px", fontWeight: "bold" }}>
                          06
                        </p>
                      </FormGroup>
                    </Col>
                  </Row> */}

                  {remaingSession < 5 && (
                    <Row>
                      <Col
                        md={12}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <p
                          style={{
                            border: "2px solid black",
                            padding: "20px",
                          }}
                        >
                          <spna>
                            <i
                              class="fa-solid fa-triangle-exclamation"
                              style={{ color: "red", fontSize: "20px" }}
                            ></i>
                          </spna>
                          <span
                            style={{
                              fontSize: "16px",
                              fontWeight: "bold",
                              marginLeft: "20px",
                            }}
                          >
                            Your Class Cycle will Expire in {remaingSession}{" "}
                            Days
                          </span>
                        </p>
                      </Col>
                    </Row>
                  )}
                </CardBody>

                <CardFooter className="py-4">
                  <Label style={{ fontWeight: "bold" }}>Remark : </Label>
                  <p>{ClassData?.notes}</p>
                  <Button style={{ float: "right" }} onClick={toggle}>
                    Edit Remark
                  </Button>
                </CardFooter>
              </Card>
            </div>
          </Row>
        )}
        <Modal isOpen={modal} toggle={toggle}>
          <ModalHeader toggle={toggle}>
            <h4>Edit Remark</h4>
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={handleSubmitRemark}>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Input
                      id="forType"
                      type="textarea"
                      placeholder="Your Remark"
                      name="notes"
                      defaultValue={ClassData?.notes}
                    ></Input>
                  </FormGroup>
                </Col>
              </Row>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <Button color="secondary" onClick={toggle}>
                  Cancel
                </Button>
                {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
                <Button
                  color="primary"
                  type="submit"
                  style={{ float: "right", marginLeft: "5%" }}
                  // onClick={handleSubmitRemark}
                >
                  Save
                </Button>
              </div>
            </Form>
          </ModalBody>
        </Modal>
      </Container>
    </>
  );
};

export default AttParentDetails;
